// extracted by mini-css-extract-plugin
export default {"promoField":"PromoCodeInput_promoField__qjIFg"};